export default __webpack_public_path__ + "static/media/lhd-awd-hero-desktop.1a099921.jpg";